import CTNField from '@ctn/ui/components/ctn-field';

import { useEmpresa } from '@/context/empresa.context';

import type { ReactElement } from 'react';

const DetalleAlta = (): ReactElement => {
	const { emisor } = useEmpresa();
    
	return (
		<section className="[ c-pnp-company__start-date ] [ o-grid ] [ u-mt-16 ]">
			<header>
				<h4 className="c-pnp-heading-h4">Detalles del alta en el portal</h4>
			</header>
			<CTNField className='u-mt-16' label='fecha de alta'>
				{ emisor?.fechaAlta }
			</CTNField>
		</section>
	);
};

export default DetalleAlta;
